/**
 * @generated SignedSource<<798cb39579af674dc45b2a9c7fc7b77c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdminListUsersRequest = {
  accountId?: string | null;
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type OwnerSelectQuery$variables = {
  input: AdminListUsersRequest;
};
export type OwnerSelectQuery$data = {
  readonly adminListUsers: {
    readonly data: ReadonlyArray<{
      readonly email: string | null;
      readonly fullName: string | null;
      readonly id: string;
    }>;
  };
};
export type OwnerSelectQuery = {
  response: OwnerSelectQuery$data;
  variables: OwnerSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUserList",
    "kind": "LinkedField",
    "name": "adminListUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminUser",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OwnerSelectQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OwnerSelectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a4d579fb6ebb403a13f913c529fa68c2",
    "id": null,
    "metadata": {},
    "name": "OwnerSelectQuery",
    "operationKind": "query",
    "text": "query OwnerSelectQuery(\n  $input: AdminListUsersRequest!\n) {\n  adminListUsers(input: $input) {\n    data {\n      id\n      email\n      fullName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08190b7106d22039a717ee0b52f4e9f4";

export default node;
